export const LOGIN = 'LOGIN';
export const SET_LOGIN_ERRORS = 'SET_LOGIN_ERRORS';
export const LOGOUT = 'LOGOUT';
export const SET_MESSAGE_SENT_ERRORS = 'SET_MESSAGE_SENT_ERRORS';
export const SET_GROUP_CHAT_CREATION_ERRORS = 'SET_GROUP_CHAT_CREATION_ERRORS';
export const SET_COMMON_ERRORS = 'SET_COMMON_ERRORS';
